import React from "react";
import { Link } from "react-router-dom";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { useI18n } from "@/contexts/LanguageContext";

export default function MarketingFooter() {
  const { t } = useI18n();
  const year = new Date().getFullYear();
  return (
    <footer
      className="mt-24 border-t"
      style={{ borderColor: "hsl(var(--nvl-border))" }}
      data-testid="marketing-footer"
    >
      <div className="nvl-container py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="font-display text-2xl tracking-tight">NO VAX LOVE</div>
          <p className="mt-3 max-w-md text-sm" style={{ color: "hsl(var(--nvl-ink-soft))" }}>
            {t("common.slogan")}
          </p>
          <div className="mt-6">
            <LanguageSwitcher />
          </div>
        </div>
        <div>
          <div className="nvl-overline mb-4" style={{ color: "hsl(var(--nvl-ink-soft))" }}>
            NO VAX LOVE
          </div>
          <ul className="space-y-2 text-sm">
            <li><a href="/legal/privacy#controller" className="underline-offset-4 hover:underline" data-testid="footer-about">{t("landing.footer.about")}</a></li>
            <li><a href="/legal/privacy#contacts" className="underline-offset-4 hover:underline" data-testid="footer-contact">{t("landing.footer.contact")}</a></li>
          </ul>
        </div>
        <div>
          <div className="nvl-overline mb-4" style={{ color: "hsl(var(--nvl-ink-soft))" }}>
            {t("landing.legalLabel")}
          </div>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/legal/privacy" className="underline-offset-4 hover:underline"
                    data-testid="footer-legal-privacy">
                {t("landing.footer.privacy")}
              </Link>
            </li>
            <li>
              <Link to="/legal/terms" className="underline-offset-4 hover:underline"
                    data-testid="footer-legal-terms">
                {t("landing.footer.terms")}
              </Link>
            </li>
            <li>
              <Link to="/legal/cookies" className="underline-offset-4 hover:underline"
                    data-testid="footer-legal-cookies">
                {t("app.legal.cookiesTitle")}
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div
        className="nvl-container pb-10 text-xs"
        style={{ color: "hsl(var(--nvl-ink-soft))" }}
      >
        © {year} NO VAX LOVE. {t("landing.footer.rights")}
      </div>
    </footer>
  );
}
